import { render, staticRenderFns } from "./Carne.vue?vue&type=template&id=7c022250&lang=pug&"
import script from "./Carne.vue?vue&type=script&lang=js&"
export * from "./Carne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports